import { Box, Divider, Skeleton } from "@mui/material";

import useThemeData from "@/hooks/useThemeData";

const AlertListSkeleton = () => {
  const theme = useThemeData();

  return (
    <div className="space-y-[20px]">
      {new Array(3).fill("").map((_, i) => (
        <div
          style={{
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.palette.divider,
          }}
          key={i}
        >
          <Box className="p-[10px]">
            <Skeleton />
            <Skeleton animation="wave" />
            <Skeleton animation={false} />
            <Skeleton />
            <Skeleton animation="wave" />
            <Skeleton animation={false} />
          </Box>
          <Divider />
          <div className="flex justify-between items-center p-[10px]">
            <Skeleton className="w-[40px]" />
            <Skeleton className="w-[40px]" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default AlertListSkeleton;
